<template>
    <Card class="card">
      <h2>{{title}}</h2>
      <h4 v-for="i in textList" :key="i">{{ i }}</h4>
      <div class="content">
        <Table size='small' class='activeList' ref="selection" border :loading='isLoading' highlight-row :columns="columns" :data="data"  :max-height="500"></Table>
      </div>
    </Card>
</template>

<script>
import { Card, Table } from 'view-design'
export default {
  name: 'getOrgList',
  components: { Card, Table },
  data () {
    return {
      exportBut: false,
      searchValue: '',
      isLoading: false,
      columns: [
        {
          title: '',
          key: 'number',
          width: 70,
          align: 'center'
        },
        {
          title: '',
          key: 'student',
          align: 'center',
          minWidth: 60
        },
        {
          title: '',
          key: 'txt_name',
          align: 'center',
          minWidth: 180
        },
        {
          title: '',
          key: 'name',
          align: 'center',
          minWidth: 100
        },
        {
          title: '',
          key: 'teacher',
          align: 'center',
          minWidth: 60
        }],
      data: [],
      title: '',
      textList: []
    }
  },
  computed: {
  },
  methods: {
    getData () {
      fetch('./announced.json')
        .then(response => response.json()).then(data => {
          this.title = data.top_title
          this.textList = data.textList
          data.value.forEach((item, index) => {
            this.data.push(item)
          })
          this.columns.forEach((item, index) => {
            item.title = data.title[index]
          })
        }).catch(err => console.log("获取表格失败", err))
    }
  },
  beforeCreate () {
  },
  created () {
    this.getData()
  },
  mounted () {
  }
}
</script>

<style lang = 'scss' scoped>
@import '../../assets/scss/public.scss';
h2{
  text-align: center;
  margin-bottom: 1rem;
}
h4{
  width: 100%;
  padding: 0 2%;
  padding-bottom: 0.5rem;
  text-indent: 2em;
}
.card {
  position: relative;
  z-index: 999;
  width: 50%;
  min-width: 85rem;
  margin: 5rem auto;
  .content{
    width: 100%;
    padding: 10px;
  }
}
</style>
